module.exports = __webpack_public_path__ + "img/img7.565adf5a.svg";